'use client';

import { useEffect } from 'react';
import { sendGTMEvent } from '@/lib/gtm-wrapper';
import { getEcommerceBodyForProduct, GTMEventType } from '@/lib/GTMEventType';
import { Product } from '@/models/Product';

export default function ProductPageGTMReporter({ product }: { product: Product }) {
  useEffect(() => {
    sendGTMEvent({
      event: GTMEventType.VIEW_ITEM,
      ecommerce: getEcommerceBodyForProduct(
        product,
        product?.category?.id?.toString() || '',
        product?.category?.title || '',
      ),
    });
  }, [product]);

  return null;
}
